import { writable } from 'svelte/store';
import { TimePeriod } from './TimePeriod';
export const appState = writable({
    albumRequest: {
        user: undefined,
        minPlayCount: 10,
        maxPlayCount: undefined,
        period: TimePeriod.OVERALL
    },
    formSent: false
});
